/* eslint-disable no-case-declarations */
import { gql } from 'graphql-request';
import { createQuery } from '@fivehealth/botero';
import { get } from 'lodash';

export const GRAPHQL_SUBMISSIONS_EXPORTED_FORMATS = gql`
  query cleoSubmissionsExportedFormats {
    cleoSubmissions {
      exportFormats {
        label
        outputFormat
        allowEmail
      }
    }
  }
`;

export default createQuery({
  gqlDocument: GRAPHQL_SUBMISSIONS_EXPORTED_FORMATS,
  queryType: 'query',
  baseQueryKey: 'submissionsExportedFormats',
  select: (data) =>
    get(data, 'cleoSubmissions.exportFormats')?.map((o) => ({
      value: o.outputFormat?.toLowerCase(),
      label: o.label,
      allowEmail: o.allowEmail,
      selected: false,
    })),
  keepPreviousData: true,
});
